import React from 'react';
import { theme } from '../theme';

function ConfirmationModal({ 
  isVisible, 
  title, 
  message, 
  onConfirm, 
  onCancel,
  confirmText = 'Yes',
  cancelText = 'No',
  confirmButtonStyle = theme.buttonPrimary, // Use theme color
  isDestructive = false,
  showCancel = true
}) {
  if (!isVisible) return null;

  const confirmStyle = isDestructive ? theme.buttonDanger : confirmButtonStyle;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center'
      }}>
        <h3 style={{ 
          margin: '0 0 1rem 0', 
          color: isDestructive ? theme.buttonDanger : theme.text,
          fontSize: '1.5rem'
        }}>
          {title}
        </h3>
        <p style={{ 
          margin: '0 0 2rem 0', 
          fontSize: '1.1rem',
          color: theme.text
        }}>
          {message}
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          {showCancel && (
            <button
              onClick={onCancel}
              style={{
                padding: '0.75rem 2rem',
                backgroundColor: theme.buttonSecondary,
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: '500'
              }}
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={onConfirm}
            style={{
              padding: '0.75rem 2rem',
              backgroundColor: confirmStyle,
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: 'bold'
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
